import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { SowaError } from '../../lib/xfetch';
import { ErrorLogger } from '../../lib/error-loger';
import {
  ApiError,
  TechnicalError,
  IncorrectDataError,
  OtherError,
  UnknownServerMessageError,
  SurveyFormFetchingError,
  SurveyAlreadyCompletedError,
  SurveyFormFetchingCodeError
} from '../../api';
import { NextQuestionNotFoundError, StartQuestionNotFoundError, UnknownAnswerTypeError } from '../../survey';
import { CmIdNotFoundError, PageNotFoundError } from '../logic';
import { TechnicalErrorView } from './TechnicalErrorView';
import { SurveyNotFoundErrorView } from './SurveyNotFoundErrorView';
import { SurveyAlreadyCompletedErrorView } from './SurveyAlreadyCompletedErrorView';
import { SurveyFormFetchingErrorView } from './SurveyFormFetchingErrorView';
import { UnknownErrorView } from './UnknownErrorView';

/**
 * Отображение экрана ошибки в зависимости от типа ошибки.
 * Логирование ошибки в консоль.
 */
export const ErrorView: FC<{
  error: unknown;
}> = observer(({ error }) => {
  ErrorLogger.log(error);

  if (error instanceof ApiError) {
    if (error.cause instanceof SowaError) {
      // при такой ошибке сразу обновлять страницу бесполезно
      return <TechnicalErrorView />;
    }

    if (error instanceof SurveyFormFetchingError) {
      if (error instanceof SurveyAlreadyCompletedError) {
        return <SurveyAlreadyCompletedErrorView />;
      }

      if (error instanceof SurveyFormFetchingCodeError) {
        if (error instanceof TechnicalError || error instanceof IncorrectDataError) {
          return <TechnicalErrorView />;
        }

        if (error instanceof OtherError) {
          return <SurveyFormFetchingErrorView />;
        }

        return <SurveyNotFoundErrorView />;
      }

      if (error instanceof UnknownServerMessageError) {
        return <SurveyFormFetchingErrorView />;
      }
    }
  }

  if (
    error instanceof UnknownAnswerTypeError ||
    error instanceof NextQuestionNotFoundError ||
    error instanceof StartQuestionNotFoundError
  ) {
    return <TechnicalErrorView />;
  }

  if (error instanceof CmIdNotFoundError || error instanceof PageNotFoundError) {
    return <SurveyNotFoundErrorView />;
  }

  // бывает, что сбоит авторизация, sowa или интернет, и перезагрузка страницы может помочь
  return <UnknownErrorView />;
});
